var _path, _rect, _line, _line2, _path2, _line3, _line4, _line5, _rect2, _rect3, _rect4, _path3, _path4, _rect5, _rect6, _rect7, _line6, _rect8, _line7, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebdevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 78,
    viewBox: "0 0 132 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9995 58.0005L42.2368 66.4496H61.6322H61.9079H62.7631L59.9995 58.0005H44.9995Z",
    fill: "#38C1C9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.7104,
    y: 11.7104,
    width: 61.5789,
    height: 46.1842,
    rx: 3,
    fill: "#E6FEFC",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 8.84309,
    y2: -0.5,
    transform: "matrix(-0.316228 0.948683 -0.948684 -0.316227 44.6213 57.2729)",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 8.84309,
    y2: -0.5,
    transform: "matrix(0.316228 0.948683 0.948684 -0.316227 60.3787 57.2729)",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9739 68.1578C31.9739 67.2131 32.7397 66.4473 33.6844 66.4473H71.316C72.2607 66.4473 73.0265 67.2131 73.0265 68.1578V68.1578C73.0265 69.1025 72.2607 69.8683 71.316 69.8683H33.6844C32.7397 69.8683 31.9739 69.1025 31.9739 68.1578V68.1578Z",
    fill: "#38C1C9",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 20.5996,
    x2: 29.9,
    y2: 20.5996,
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 34.9004,
    y1: 20.5996,
    x2: 37.8004,
    y2: 20.5996,
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 42.8008,
    y1: 20.5996,
    x2: 45.7008,
    y2: 20.5996,
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 26.8999,
    width: 13,
    height: 20.9,
    rx: 1,
    fill: "#FFEF85",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 26.8999,
    width: 13,
    height: 20.9,
    rx: 1,
    fill: "#FFC3AE",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 26.8999,
    width: 13,
    height: 20.9,
    rx: 1,
    fill: "#BAC4FF",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0801 62.9204H111.154V64.9604C111.154 66.6173 109.81 67.9604 108.154 67.9604H94.0801C92.4232 67.9604 91.0801 66.6173 91.0801 64.9604V62.9204Z",
    fill: "#38C1C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0808 36.9404C91.0808 35.2836 92.424 33.9404 94.0808 33.9404H108.154C109.811 33.9404 111.154 35.2836 111.154 36.9404V61.6604H91.0808V36.9404Z",
    fill: "#E6FEFC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4248,
    y: 42.7598,
    width: 13.3824,
    height: 3.78,
    rx: 1,
    fill: "#FFEF85",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4248,
    y: 49.0596,
    width: 13.3824,
    height: 3.78,
    rx: 1,
    fill: "#FFC3AE",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4248,
    y: 55.3599,
    width: 13.3824,
    height: 3.78,
    rx: 1,
    fill: "#BAC4FF",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 94.2568,
    y1: 38.4795,
    x2: 95.9333,
    y2: 38.4795,
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 91.0808,
    y: 33.9404,
    width: 20.0735,
    height: 34.02,
    rx: 3,
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 91.5801,
    y1: 62.4204,
    x2: 110.654,
    y2: 62.4204,
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.955 65.0618C101.955 65.4535 101.608 65.8218 101.117 65.8218C100.625 65.8218 100.278 65.4535 100.278 65.0618C100.278 64.67 100.625 64.3018 101.117 64.3018C101.608 64.3018 101.955 64.67 101.955 65.0618Z",
    stroke: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdevelopment);
export default __webpack_public_path__ + "static/media/webdevelopment.68fd198544b8c12ecc303e2e3137a115.svg";
export { ForwardRef as ReactComponent };